import { ListChecks } from 'lucide-react'

import Button from '@/elements/Button'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import NotificationsList from '@/components/NotificationsList'
import useBreakpoints from '@/hooks/useBreakpoints'
import { markNotificationAsRead, useGetNotifications, useGetUnreadNotificationsCount } from '@/api/notifications'
import Pagination from '@/components/Pagination'
import usePagination from '@/hooks/usePagination'

function Notifications() {
  const { isMobile } = useBreakpoints()
  const { page, limit, setPage } = usePagination(8)

  const { data: unreadData } = useGetUnreadNotificationsCount()
  const unreadCount = unreadData?.data || 0

  const { data: notificationData, refetch, isLoading } = useGetNotifications({ page, limit })
  const notifications = notificationData?.data?.items || []

  return (
    <Flex component='section' gap={4} grow>
      <Flex inline wfull justify='space-between' align='center' gap={2} wrap>
        <Text variant='h1'>
          Notifications
        </Text>
        <Button
          variant='primary'
          fullWidth={isMobile}
          onClick={() => markNotificationAsRead().then(() => refetch())}
          disabled={unreadCount === 0}
        >
          <ListChecks size={18} />
          Mark all as read
        </Button>
      </Flex>
      <NotificationsList
        refetch={refetch}
        loading={isLoading}
        notifications={notifications}
      />
      <Flex wfull align='center' pt={4} mt='auto' gap={3}>
        <Pagination
          variant={isMobile ? 'compact' : 'default'}
          onPageChange={setPage}
          {...notificationData?.data?.pagination}
        />
      </Flex>
    </Flex>
  )
}

export default Notifications
